module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-doc_gray.2539318d.svg";